import { render } from "./ImportComponent.vue?vue&type=template&id=45b00486"
import script from "./ImportComponent.vue?vue&type=script&lang=js"
export * from "./ImportComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/h5/ImportComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45b00486"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45b00486', __exports__)) {
    api.reload('45b00486', __exports__)
  }
  
  module.hot.accept("./ImportComponent.vue?vue&type=template&id=45b00486", () => {
    api.rerender('45b00486', render)
  })

}


export default __exports__